import ArchitectureBg from 'src/shared/assets/architecture-bg.jpg'
import { Button } from 'src/shared/components/ui/buttons/button'

export const AppErrorBoundary = () => {
  return (
    <div className="flex min-h-screen bg-accent">
      <div
        className="hidden bg-cover bg-center lg:block lg:w-1/2"
        style={{ backgroundImage: `url(${ArchitectureBg})` }}
      ></div>
      <div className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <h2 className="mt-6 text-3xl font-semibold text-primary">Connectivity Issues</h2>
            <p className="mt-2 text-sm text-muted">
              We&apos;re experiencing some connectivity issues. Please check your internet connection and try again.
            </p>
          </div>
          <div className="mt-8 flex justify-center">
            <Button
              variant="default"
              size="xl"
              className="w-[200px] rounded-full"
              onClick={() => window.location.reload()}
            >
              Retry
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
